import React, { useEffect } from 'react';

/**
 * Composant Loader
 * Affiche une animation de chargement avec Tailwind
 * 
 * @param {Object} props - Props du composant
 * @param {boolean} props.isVisible - Si le loader doit être visible
 */
export default function Loader({ 
    isVisible = true, 
}) {
    // Ajouter un effet pour logger lorsque le loader devient visible/invisible
    useEffect(() => {
        // Vérifier si on est en localhost pour afficher les logs
        // const isLocalhost = window.location.hostname === 'localhost' || 
        //                    window.location.hostname === '127.0.0.1';
        
        const isLocalhost = false

        if (isLocalhost) {
            if (isVisible) {
                console.log('%c💥 LOADER AFFICHÉ - COMPOSANT MOUNTÉ', 'color: #10B981; font-weight: bold; font-size: 14px');
            } else {
                console.log('%c💥 LOADER CACHÉ', 'color: #EF4444; font-weight: bold; font-size: 14px');
            }
        }
    }, [isVisible]);

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-[9999] bg-white/80 backdrop-blur-lg">
            <div className="p-8 flex flex-col items-center">
                {/* Icône avec animation de rotation et texte */}
                <div className="animate-spin mb-4">
                    <svg className="w-16 h-16 text-teal-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-95" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                </div>
                <div className="text-teal-600 font-bold text-xl">Chargement...</div>
            </div>
        </div>
    );
}